module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[46]167.ead60b8.woff2";